type LoaderProps = {
  variant?: "default" | "light";
  size: "sm" | "md" | "lg";
};

export function Loader(props: LoaderProps) {
  return (
    <div
      class="ui-loader"
      style={{
        "--loader-size": loaderSize(props.size),
        "--loader-color": loaderColor(props.variant ?? "default"),
      }}
    />
  );
}

function loaderSize(size: LoaderProps["size"]) {
  switch (size) {
    case "sm":
      return "0.25em";
    case "md":
      return "0.5em";
    case "lg":
      return "1em";
  }
}

function loaderColor(variant: LoaderProps["variant"]) {
  switch (variant) {
    case "default":
      return "var(--color-brand-primary)";
    case "light":
      return "var(--color-typography-primary-dark)";
  }
}
